module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row",
    style: (_vm.cstyle)
  }, [_c('div', {
    class: _vm.searchClass
  }, [_c('div', {
    staticClass: "input-group"
  }, [(_vm.hasSearch) ? _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "tabindex": "-1",
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.clearSearch()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })])]) : _vm._e(), _vm._v(" "), (_vm.hasSearch) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchValue),
      expression: "searchValue"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Suchen ...",
      "id": "deceased-search"
    },
    domProps: {
      "value": (_vm.searchValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchValue = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.hasSearch) ? _c('div', {
    staticClass: "input-group-btn search-criteria-select-container"
  }, [_vm._m(0), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', [_c('a', {
    staticClass: "small",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "tabindex": "-1"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.exactValue = !_vm.exactValue
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.exactValue),
      expression: "exactValue"
    }],
    attrs: {
      "type": "checkbox",
      "syle": "display: block;",
      "value": "Exakte Übereinstimmung",
      "name": "exaktValueCheckbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.exactValue) ? _vm._i(_vm.exactValue, "Exakte Übereinstimmung") > -1 : (_vm.exactValue)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.exactValue,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "Exakte Übereinstimmung",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.exactValue = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.exactValue = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.exactValue = $$c
        }
      }
    }
  }), _vm._v(" Exakten Wert")])]), _vm._v(" "), _c('li', {
    staticClass: "divider"
  }), _vm._v(" "), _c('li', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.andSearchMode = !_vm.andSearchMode
      }
    }
  }, [_vm._v("Modus: " + _vm._s(_vm.andSearchMode ? 'UND' : 'ODER'))])]), _vm._v(" "), _c('li', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.inclusiveSearchMode = !_vm.inclusiveSearchMode
      }
    }
  }, [_vm._v("Modus: " + _vm._s(_vm.inclusiveSearchMode ? 'Suchen' : 'Ignorieren'))])]), _vm._v(" "), _c('li', {
    staticClass: "divider"
  }), _vm._v(" "), _c('li', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.selectAll()
      }
    }
  }, [_vm._v("Alles auswählen")])]), _vm._v(" "), _c('li', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.selectNone()
      }
    }
  }, [_vm._v("Alles abwählen")])]), _vm._v(" "), _c('li', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.selectInverse()
      }
    }
  }, [_vm._v("Auswahl umkehren")])]), _vm._v(" "), _c('li', {
    staticClass: "divider"
  }), _vm._v(" "), _vm._l((_vm.criterias), function(currCriteria) {
    return _c('li', [_c('a', {
      staticClass: "small",
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "tabindex": "-1"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.toggleChecked(currCriteria)
        }
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (currCriteria.checked),
        expression: "currCriteria.checked"
      }],
      attrs: {
        "type": "checkbox",
        "syle": "display: block;"
      },
      domProps: {
        "checked": Array.isArray(currCriteria.checked) ? _vm._i(currCriteria.checked, null) > -1 : (currCriteria.checked)
      },
      on: {
        "__c": function($event) {
          var $$a = currCriteria.checked,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (currCriteria.checked = $$a.concat($$v))
            } else {
              $$i > -1 && (currCriteria.checked = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            currCriteria.checked = $$c
          }
        }
      }
    }), _vm._v(" " + _vm._s(currCriteria.name))])])
  })], 2)]) : _vm._e()])]), _vm._v(" "), (_vm.hasAddButton || _vm.hasPrintButton) ? _c('div', {
    staticClass: "col-xs-2"
  }, [(_vm.hasAddButton) ? _c('a', {
    staticClass: "btn btn-primary pull-right",
    attrs: {
      "href": _vm.addURL === '' ? null : _vm.addURL
    },
    on: {
      "click": function($event) {
        _vm.$emit('add')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })]) : _vm._e(), _vm._v(" "), (_vm.hasPrintButton) ? _c('span', {
    staticClass: "btn btn-success pull-right",
    on: {
      "click": function($event) {
        _vm.$emit('print', _vm.printModels())
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-print"
  })]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('br'), _vm._v(" "), (_vm.filteredModel.length > 0) ? _c('div', {
    staticClass: "col-lg-12"
  }, [_vm._v("\n\t\t\tZeige\n\t\t\t"), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rowMeter),
      expression: "rowMeter"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.rowMeter = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [(_vm.entryCount >= 5) ? _c('option', {
    attrs: {
      "value": "5"
    }
  }, [_vm._v("5")]) : _vm._e(), _vm._v(" "), (_vm.entryCount >= 10) ? _c('option', {
    attrs: {
      "value": "10"
    }
  }, [_vm._v("10")]) : _vm._e(), _vm._v(" "), (_vm.entryCount >= 20) ? _c('option', {
    attrs: {
      "value": "20"
    }
  }, [_vm._v("20")]) : _vm._e(), _vm._v(" "), (_vm.entryCount >= 50) ? _c('option', {
    attrs: {
      "value": "50"
    }
  }, [_vm._v("50")]) : _vm._e(), _vm._v(" "), (_vm.entryCount >= 100) ? _c('option', {
    attrs: {
      "value": "100"
    }
  }, [_vm._v("100")]) : _vm._e(), _vm._v(" "), (_vm.entryCount >= 200) ? _c('option', {
    attrs: {
      "value": "200"
    }
  }, [_vm._v("200")]) : _vm._e(), _vm._v(" "), (_vm.entryCount >= 500) ? _c('option', {
    attrs: {
      "value": "500"
    }
  }, [_vm._v("500")]) : _vm._e(), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("Alle")])]), _vm._v("\n\t\t\tvon " + _vm._s(_vm.filteredModel.length) + " Einträgen pro Seite " + _vm._s(_vm.selectText) + "\n\t\t")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('br'), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('table', {
    staticClass: "table table-striped table-hover"
  }, [_c('thead', [_c('tr', [(_vm.hasMultiSelect) ? _c('th', {
    on: {
      "click": function($event) {
        _vm.togglePageCheck()
      }
    }
  }, [_c('span', {
    class: _vm.checkClass
  })]) : _vm._e(), _vm._v(" "), _vm._l((_vm.cols), function(col) {
    return (_vm.hasSort) ? _c('th', {
      class: _vm.parseCSS(col),
      staticStyle: {},
      on: {
        "click": function($event) {
          _vm.setSortBy(col.json)
        }
      }
    }, [_c('span', {
      class: col.style,
      staticStyle: {
        "margin-right": "5px"
      }
    }), _vm._v(_vm._s(col.name) + "\n\t\t\t\t\t\t\t"), (typeof col.hint === 'string' && col.hint !== '') ? _c('div', {
      staticClass: "custom_tooltip"
    }, [_c('span', {
      staticClass: "fa fa-info-circle"
    }), _vm._v(" "), _c('div', {
      staticClass: "custom_tooltiptext"
    }, _vm._l((col.hint.split('<br>')), function(line) {
      return _c('div', [_vm._v(_vm._s(line))])
    }))]) : _vm._e()]) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.cols), function(col) {
    return (!_vm.hasSort) ? _c('th', {
      class: _vm.parseCSS(col)
    }, [_vm._v(" \n\t\t\t\t\t\t\t" + _vm._s(col.name) + "\n\t\t\t\t\t\t\t"), (typeof col.hint === 'string' && col.hint !== '') ? _c('div', {
      staticClass: "custom_tooltip"
    }, [_c('span', {
      staticClass: "fa fa-info-circle"
    }), _vm._v(" "), _c('div', {
      staticClass: "custom_tooltiptext"
    }, _vm._l((col.hint.split('<br>')), function(line) {
      return _c('div', [_vm._v(_vm._s(line))])
    }))]) : _vm._e()]) : _vm._e()
  }), _vm._v(" "), (_vm.hasRowButtons) ? _c('th', [_vm._v(" ")]) : _vm._e()], 2)]), _vm._v(" "), _c('tbody', _vm._l((_vm.allModels), function(model) {
    return _c('tr', [(_vm.hasMultiSelect) ? _c('td', {
      on: {
        "click": function($event) {
          _vm.toggleModelChecked(model)
        }
      }
    }, [_c('span', {
      class: model['_checked'] === false ? 'fa fa-square-o' : 'fa fa-check-square-o'
    })]) : _vm._e(), _vm._v(" "), _vm._l((_vm.cols), function(col) {
      return _c('td', {
        class: _vm.parseCSS(col, model),
        style: (_vm.parseStyle(col, model)),
        on: {
          "click": function($event) {
            _vm.toggleModelChecked(model)
          }
        }
      }, [_vm._l((_vm.parse(col.type, model[col.json], col, model)), function(line) {
        return _c('p', [(col.type !== 'url') ? _c('span', {
          class: _vm.parseColCSS(col, model[col.json], model),
          style: (_vm.parseColStyle(col, model[col.json]))
        }, [_vm._v(_vm._s(line))]) : _vm._e()])
      }), _vm._v(" "), (col.type === 'url') ? _c('a', {
        attrs: {
          "href": _vm.parse(col.type, model, col)
        }
      }, [_vm._v("Link")]) : _vm._e()], 2)
    }), _vm._v(" "), (_vm.hasRowButtons) ? _c('td', [_c('span', {
      staticClass: "pull-right"
    }, [(_vm.hasDelButton) ? _c('span', {
      class: _vm.rowSpanClass,
      staticStyle: {
        "text-align": "right"
      }
    }, [_c('a', {
      staticClass: "btn btn-danger btn-sm",
      attrs: {
        "href": _vm._f("parseURL")(_vm.delURL === '' ? null : _vm.delURL, model)
      },
      on: {
        "click": function($event) {
          _vm.$emit('delete', model)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })])]) : _vm._e(), _vm._v(" "), (_vm.hasEditButton) ? _c('span', {
      class: _vm.rowSpanClass,
      staticStyle: {
        "text-align": "right"
      }
    }, [_c('a', {
      staticClass: "btn btn-primary btn-sm",
      attrs: {
        "href": _vm._f("parseURL")(_vm.editURL === '' ? null : _vm.editURL, model)
      },
      on: {
        "click": function($event) {
          _vm.$emit('edit', model)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil"
    })])]) : _vm._e(), _vm._v(" "), (_vm.hasSelectButton) ? _c('span', {
      class: _vm.rowSpanClass,
      staticStyle: {
        "text-align": "right"
      }
    }, [_c('a', {
      staticClass: "btn btn-success btn-sm",
      attrs: {
        "href": _vm._f("parseURL")(_vm.selURL === '' ? null : _vm.selURL, model)
      },
      on: {
        "click": function($event) {
          _vm.$emit('select', model)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-arrow-right"
    })])]) : _vm._e(), _vm._v(" "), (_vm.hasRowAddButton) ? _c('span', {
      class: _vm.rowSpanClass,
      staticStyle: {
        "text-align": "right"
      }
    }, [_c('a', {
      staticClass: "btn btn-success btn-sm",
      attrs: {
        "href": _vm._f("parseURL")(_vm.selURL === '' ? null : _vm.selURL, model)
      },
      on: {
        "click": function($event) {
          _vm.$emit('rowAdd', model)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-plus"
    })])]) : _vm._e()])]) : _vm._e()], 2)
  })), _vm._v(" "), (_vm.pageCount > 1) ? _c('tfoot', [_c('td', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "colspan": _vm.colCount
    }
  }, [_c('nav', {
    attrs: {
      "aria-label": "Page navigation"
    }
  }, [_c('ul', {
    staticClass: "pagination"
  }, [(_vm.page > 2) ? _c('li', {
    staticClass: "active"
  }, [_c('a', {
    staticClass: "fa fa-step-backward",
    attrs: {
      "aria-label": "First"
    },
    on: {
      "click": function($event) {
        _vm.firstPage()
      }
    }
  })]) : _vm._e(), _vm._v(" "), _vm._l((_vm.pageBefore), function(index) {
    return _c('li', [_c('a', {
      on: {
        "click": function($event) {
          _vm.setPage(index)
        }
      }
    }, [_vm._v(_vm._s(parseInt(index) + 1))])])
  }), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_c('a', [_vm._v(_vm._s(parseInt(_vm.page) + 1))])]), _vm._v(" "), _vm._l((_vm.pageAfter), function(index) {
    return _c('li', [_c('a', {
      on: {
        "click": function($event) {
          _vm.setPage(index)
        }
      }
    }, [_vm._v(_vm._s(index + 1))])])
  }), _vm._v(" "), (_vm.page < _vm.pageCount - 3) ? _c('li', {
    staticClass: "active"
  }, [_c('a', {
    staticClass: "fa fa-step-forward",
    on: {
      "click": function($event) {
        _vm.lastPage()
      }
    }
  })]) : _vm._e()], 2)])])]) : _vm._e()])])]), _vm._v(" "), (_vm.hasMultiSelect) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('button', {
    staticClass: "btn btn-primary pull-right",
    attrs: {
      "disabled": _vm.selectedItemCount === 0
    },
    on: {
      "click": _vm.sendMultiSelect
    }
  }, [_vm._v(_vm._s(_vm.multiselectText))])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn btn-default dropdown-toggle",
    attrs: {
      "tabindex": "-1",
      "data-toggle": "dropdown",
      "type": "button"
    }
  }, [_c('span', {
    staticClass: "caret"
  }), _vm._v(" "), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Dropdown")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-948f6fe6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/custom-table.vue
// module id = 459
// module chunks = 0